import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/WorkFlowListService";
const store = {};
const mutations = {
    GET_WORKFLOW_DETAIL(state, posts) {
        state.workflow = posts.data;
        state.fieldAccess = posts.fieldAccess;
        state.isLoading = false;
    },
    GET_WF_TRANSITION(state, posts) {
        state.workflowTransition = posts.transitionList;
        state.isLoading = false;
    },
    GET_WORKFLOW_LIST(state, posts) {
        state.workflowList = posts.data;
        state.isLoading = false;
    },
};
const state = {
    workflow: [],
    fieldAccess: [],
    workflowTransition: [],
    workflowList: [],
    isLoading: false
};
const getters = {};
const actions = {
    getWorkflowDetail({ commit }) {
        state.isLoading = true;
        axios
            .get(baseUri + '/GetDetail')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_WORKFLOW_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getWfTransition({ commit }) {
        state.isLoading = true;
        axios
            .get(baseUri + '/GetWfTransition')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_WF_TRANSITION', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getWorkflowList({ commit }) {
        state.isLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_WORKFLOW_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}